<shared-systembar class="format-landing-page_system-bar" [configuration]="systembarConfiguration" (loadingReady)="removeLoadingOverlay()"></shared-systembar>
@if (adminService.isAdmin()) {
  <admin-menu>
    <router-outlet></router-outlet>
  </admin-menu>
} @else {
  <div class="format-landing-page_router-wrapper">
    <router-outlet></router-outlet>
  </div>
}
